import apiClient from './apiClient';

export const employeeService = {
  list: (params) =>
    apiClient.get('/api/employees', { params }).then((r) => r.data),

  getOne: (id) =>
    apiClient.get(`/api/employees/${id}`).then((r) => r.data),

  create: (data) =>
    apiClient.post('/api/employees', data).then((r) => r.data),

  update: (id, data) =>
    apiClient.put(`/api/employees/${id}`, data).then((r) => r.data),

  archive: (id) =>
    apiClient.patch(`/api/employees/${id}/archive`).then((r) => r.data),

  restore: (id) =>
    apiClient.patch(`/api/employees/${id}/restore`).then((r) => r.data),
};